import { Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { useSelectSearchProps } from '../hooks';
import { countries } from '../utils/locationData';

const CountryField = ({ value, ...props }) => {
  const _props = useSelectSearchProps(countries, value);
  return (
    <Select allowClear value={value} {..._props} {...props} />
  );
};

CountryField.propTypes = {
  value: PropTypes.any
};

export default CountryField;
